import { createI18n, VueMessageType } from 'vue-i18n'

type MessageSchema = {
  [key: string]: VueMessageType | MessageSchema
}

function loadLocaleMessages(): Record<string, MessageSchema> {
  return process.env.NODE_ENV !== 'test'
    ? loadLocaleMessagesForProd()
    : loadLocaleMessagesForTesting()
}

function loadLocaleMessagesForProd(): Record<string, MessageSchema> {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages: Record<string, MessageSchema> = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key).default
    }
  })
  return messages
}

function loadLocaleMessagesForTesting(): Record<string, MessageSchema> {
  const locales: Record<string, MessageSchema> = {
    en: require('./locales/en')
  }
  const messages: Record<string, MessageSchema> = {}
  Object.keys(locales).forEach((key) => {
    messages[key] = locales[key]
  })

  return messages
}

export default createI18n<false>({
  legacy: false,
  globalInjection: true,
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
